import { Button, Kind } from '@thanx/uikit/button'
import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import palette from 'constants/palette'
import { buildTranslate } from 'locales'
import React from 'react'
import { promoCodesHelpUrl } from 'utilities/urlUtils'

const t = buildTranslate('promo_codes.overview.footer_cta')
const tHero = buildTranslate('promo_codes.overview.hero')
const tOverview = buildTranslate('promo_codes.overview')
const tLanding = buildTranslate('promo_codes.landing')

type Props = {
  onCreateClick: () => void
}

const FooterCta = ({ onCreateClick }: Props) => {
  const [css] = useStyletron()

  return (
    <section
      data-testid="promo-codes-footer-cta"
      className={`p-l ${css({
        backgroundColor: palette.white,
        border: `1px solid ${palette.grey20}`,
        borderRadius: '8px',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '24px',
      })}`}
    >
      <div>
        <Text.Header4 tag="h2" color="grey90" className="mt-0 mb-xxs">
          {t('title')}
        </Text.Header4>
        <Text.BodyText4 color="grey70" tag="div">
          {t('body')}
        </Text.BodyText4>
      </div>
      <div className={css({ display: 'flex', gap: '12px', flexWrap: 'wrap' })}>
        <Button
          kind={Kind.SECONDARY}
          aria-label={`${tHero('learn_more')} ${tOverview(
            'opens_in_new_window'
          )}`}
          onClick={() => window.open(promoCodesHelpUrl, '_blank', 'noopener')}
        >
          {tHero('learn_more')}
        </Button>
        <Button onClick={onCreateClick} data-testid="footer-create-promo-code">
          {tLanding('create_promo_code')}
        </Button>
      </div>
    </section>
  )
}

export default FooterCta
